(() => {
  if (window.CMHomepageConversion) {
    window.CMHomepageConversion.init();
    return;
  }

  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  })[character]);

  const pushAnalytics = (payload) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  };

  if (typeof window.trackButtonClick !== 'function') {
    window.trackButtonClick = (buttonName) => {
      pushAnalytics({
        event: 'button_click',
        button_name: buttonName,
        page_type: 'homepage'
      });
    };
  }

  const onTrackedClick = (event) => {
    const link = event.target.closest('[data-cm-track]');
    if (!link) return;

    pushAnalytics({
      event: 'homepage_cta_click',
      cta_type: link.dataset.cmTrack || 'link',
      cta_label: link.dataset.cmLabel || link.textContent.trim().replace(/\s+/g, ' '),
      location: link.dataset.cmLocation || undefined,
      link_url: link.href
    });
  };

  const renderReviews = (section, place) => {
    const score = section.querySelector('[data-cm-review-score]');
    const count = section.querySelector('[data-cm-review-count]');
    const track = section.querySelector('[data-cm-review-track]');
    const link = section.querySelector('[data-cm-review-link]');

    if (place.rating && score) score.textContent = place.rating.toFixed(1);
    if (place.user_ratings_total && count) count.textContent = `${place.user_ratings_total} Google reviews`;
    if (place.url && link) link.href = place.url;

    const reviews = (place.reviews || []).slice(0, 5);
    if (!reviews.length || !track) return;

    track.innerHTML = '';
    reviews.forEach((review) => {
      const card = document.createElement('article');
      const author = escapeHtml(review.author_name || 'Google customer');
      const reviewText = escapeHtml(review.text || '');
      const shortened = reviewText.length > 360 ? `${reviewText.slice(0, 357)}…` : reviewText;
      const avatar = review.profile_photo_url
        ? `<img src="${escapeHtml(review.profile_photo_url)}" width="42" height="42" alt="" loading="lazy">`
        : `<span class="cm-home-review__avatar" aria-hidden="true">${author.slice(0, 1)}</span>`;

      card.innerHTML = `
        <span class="cm-home-review__stars" aria-label="${Number(review.rating || 5)} out of 5 stars">★★★★★</span>
        <p>“${shortened}”</p>
        <div class="cm-home-review__author">
          ${avatar}
          <div>
            <strong>${author}</strong>
            <small>${escapeHtml(review.relative_time_description || 'Google review')}</small>
          </div>
        </div>`;
      track.appendChild(card);
    });
  };

  const hydrateReviewSection = (section) => {
    if (section.dataset.cmReviewsLoaded === 'true') return;
    if (!window.google?.maps?.places) return;

    section.dataset.cmReviewsLoaded = 'true';
    const service = new window.google.maps.places.PlacesService(document.createElement('div'));
    service.getDetails({
      placeId: section.dataset.placeId,
      fields: ['url', 'rating', 'user_ratings_total', 'reviews']
    }, (place, status) => {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK || !place) {
        section.dataset.cmReviewsLoaded = 'false';
        return;
      }
      renderReviews(section, place);
    });
  };

  const hydrateAllReviews = () => {
    document.querySelectorAll('[data-cm-reviews]').forEach(hydrateReviewSection);
  };

  const loadGooglePlaces = () => {
    const sections = document.querySelectorAll('[data-cm-reviews]');
    if (!sections.length) return;

    if (window.google?.maps?.places) {
      hydrateAllReviews();
      return;
    }

    if (document.querySelector('script[data-cm-google-places]')) return;

    const key = sections[0].dataset.mapsKey;
    if (!key) return;

    window.__cmHomepageGoogleReady = hydrateAllReviews;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&callback=__cmHomepageGoogleReady&loading=async`;
    script.async = true;
    script.defer = true;
    script.dataset.cmGooglePlaces = 'true';
    document.head.appendChild(script);
  };

  const init = () => {
    loadGooglePlaces();
  };

  document.addEventListener('click', onTrackedClick);
  document.addEventListener('shopify:section:load', init);
  window.CMHomepageConversion = { init };
  init();
})();
